var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.9853 7.75531L3.97863 3.04065L5.26596 2.69531L9.89996 6.97531L13.408 6.03531C13.6642 5.96671 13.9371 6.00269 14.1668 6.13534C14.3965 6.26799 14.564 6.48645 14.6326 6.74265C14.7012 6.99884 14.6652 7.2718 14.5326 7.50147C14.3999 7.73114 14.1815 7.89871 13.9253 7.96731L3.94396 10.6406L3.42663 8.70865L3.5873 8.66531L5.23196 10.2953L3.4813 10.7646C3.33774 10.8031 3.18544 10.7926 3.04858 10.7346C2.91173 10.6766 2.79818 10.5745 2.72596 10.4446L0.977295 7.29398L1.94329 7.03531L3.5873 8.66531L6.9853 7.75465V7.75531ZM2.66663 12.6673H13.3333V14.0006H2.66663V12.6673Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlight);
export default __webpack_public_path__ + "static/media/flight.0886164deabf34ccd5f8d105dbf06b5d.svg";
export { ForwardRef as ReactComponent };